import { Eye, Fingerprint, Orbit, Sparkles } from 'lucide-react';
import type { CounselAvatar as CounselAvatarId } from '../game/types';

const ICONS = {
  cipher: Fingerprint,
  oracle: Eye,
  vector: Orbit,
  halo: Sparkles,
};

export function CounselAvatar({
  avatar,
  accent,
  className = '',
}: {
  avatar: CounselAvatarId;
  accent: string;
  className?: string;
}) {
  const Icon = ICONS[avatar];
  return (
    <span className={`counsel-avatar ${className}`} style={{ '--profile-accent': accent } as React.CSSProperties}>
      <i />
      <Icon />
    </span>
  );
}
